import { EnpsSubscriber } from '@common/utils/enps-subscriber';
import { Subject, Subscription } from 'rxjs';

export class TileColumn extends EnpsSubscriber {
    public changesSub: Subscription = new Subscription();
    public resetCostSubject = new Subject<void>();

    public value: string;

    constructor(
        public name?: string,
        public displayName?: string,
        public tiles?: Array<StorytellingRecord>,
        public dateDisplayName?: string,
        public day?: number
    ) {
        super();
    }
}
